<template>
  <div id="pdf" class="container-fluid">
    <hr>
    <div id="row">
    <img class="logo_leak logo" width="200px" :src="logoUrl">    
    <h4>nota informativa no.</h4>
      <div class="pdf__info">
        <p> <span class="pdf__titles"> Para: </span> A quien corresponda </p>
        <p> <span class="pdf__titles"> De: </span> Ingeniería e Instalaciones S.A. de C.V. </p>
        <p> <span class="pdf__titles"> Fecha: </span> {{desde}} a {{hasta}} </p>
        <p> <span class="pdf__titles"> Ducto: </span> {{site && site.section || ''}} </p>
        <p> <span class="pdf__titles"> Tramo: </span> {{site && site.sites || ''}} </p>
        <br><br>
        <p class="pdf__titles"> Vista satelital </p>
        <br><br>
        <img v-if="site" id="img_map" :src="`${site.map}`">
        <div>
          <custom-line-chart :pdesde="desde" :phasta="hasta" :pducto="site && site.sectionId || 'ZZ'" :pestacion="`${site && site.sitesIds || ''}`" :cclick="click"></custom-line-chart>
        </div>
        <div id="imgChart"></div>
         <table id="tableholder">
          <thead id="header">
            <tr id="trh">
              <th  id="thh" class="title__td">Fecha Evento</th>
              <th  id="thh" class="title__td">Kilometro</th>
              <th id="thh" class="title__td">Latitud</th>
              <th id="thh" class="title__td">Longitud</th>
              <th id="thh" class="title__td">Acción</th>
            </tr>
          </thead>
            <tbody v-if="site">
              <tr id="trw" v-for="(r, key) in site.events" :key="site.sites + '-' + key">
                <td id="tdc"> {{ r.fecha }} </td>
                <td id="tdc"> {{ r.km }} </td>
                <td id="tdc"> {{ r.lat }} </td>
                <td id="tdc"> {{ r.lng }}</td>
                <td id="tdc"> {{ r.type === 1 ? 'Apertura' : 'Cierre' }}</td>
              </tr>
              <tr id="trw-mp">
                <td id="tdc" style="color: red"> Punto medio</td>
                <td id="tdc" style="color: red"> {{ middlePoint.km.toFixed(3) }} </td>
                <td id="tdc" style="color: red"> {{ middlePoint.lat.toFixed(5) }} </td>
                <td id="tdc" style="color: red"> {{ middlePoint.lng.toFixed(5) }} </td>
                <td id="tdc" style="color: red"> </td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLineChart from 'components/Charts/CustomLineChartPdfHist'

export default {
  data() {
    return {
      click: false,
      middlePoint: {
        km: 0,
        lat: 0,
        lng: 0,
      }
    }
  },
  props: ['site', 'desde', 'hasta'],
  components: {
    CustomLineChart
  },
  computed: {
    logoUrl() {
      return require('imgs/logos/Logo_' + process.env.SITE_TYPE + '_V.png');
    }
  },
  watch: {
    site() {
      this.$store.state.cclick = true
      this.click = !this.click
      this.site.events.forEach(e => {
        this.middlePoint.km += e.km
        this.middlePoint.lat += e.lat
        this.middlePoint.lng += e.lng
      })
      this.middlePoint.km /= this.site.events.length
      this.middlePoint.lat /= this.site.events.length
      this.middlePoint.lng /= this.site.events.length
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

  #pdf {
    width: 100%;
    
    .logo_leak{
      width:200px;
      text-align:left;
    }

    .logo_pem{
      width:200px;
      float:right;
    }
    #row {
      padding: 25px;
    }
    img{
      width: 100%;
    }
    hr {
      color: var(--btn-default);
    }

    #imgChart{
      width:100%; 
      margin-top:100px;
    }
    h4 {
      text-align: center;
      text-transform: uppercase;
      color: #000;
    }
    .pdf__info {
      margin: 0 auto;
      display: block;
    }
    .pdf__titles {
      color: var(--btn-default);
    }
        
       div#pdf{
            max-height:200px;
            height:200px;
          }
         div#linechart{
            display:none;
          }
        img#leak{
              display:inline-block;
              width:115px;
            }
        img#pem{
              padding-left: 400px;
              display:inline-block;
              width:115px;
            }
       h4#h41{
              font-size:30px;
              font-weight:400;
              text-transform: uppercase;
              padding:0;
              margin-top:10px;
              margin-bottom:10px;
            }
        hr#hr1{
              	background-color: #fff;
	              border-top: 2px solid var(--btn-default);
            }
       span#titles{
            color: var(--btn-default);
            text-transform: uppercase;
            margin-left:4px;
          }
       #tablecontainer{
            height:440px;
          }
        table#tableholder{
            height: 50%;
            width:100%;
            margin:0;
            text-align:center;
          }
         thead#header{
             width:100%;
             padding:2px;
             background-color:var(--btn-default);
          }
          tr#trh{
             width:100%;
             padding:2px;
             background-color:var(--btn-default);
          }
          th#thh{
             font-size:12pt;
             align:left;
             font-weight:400;
             padding:5px;
             border: 1.5px solid var(--btn-default);
             color:white;
          }
          td#tdc{
             font-size:10pt;
             text-align:left;
             padding:2px;
             border: 1px solid #777777;
          }
  }
</style>



// WEBPACK FOOTER //
// PdfDiv.vue?593621f6